<div *ngIf="block.data.documentId || block.data.buttonLink" class="download">
    <a
        [core-analytics]="{ action: block.data.documentId || block.data.buttonLink, block }"
        [href]="getDownloadUrl()"
        [target]="block.data.target ?? '_blank'">
        <span *ngIf="block.data.downloadText" [innerHTML]="block.data.downloadText"></span>
    </a>
</div>
